export const NAV_LINKS = [
    { href: "/", label: "Home" },
    { href: "/tree", label: "Family tree" },
    { href: "/history", label: "Our history" }
] as const

export const SHARE_LINK = { href: "/share", label: "Share a memory" } as const

export const HERO = {
    eyebrow: "The family of Marga Theron",
    title: "Every name in our family is a story worth keeping.",
    text: "The Theron family tree, the moments that shaped us and the memories we hold dear, gathered in one place so every generation can find its way home.",
    primary: "Explore the family tree",
    secondary: "Share a memory",
    imageAlt: "A hand holding a small stack of black and white instant photographs"
} as const

export const CONTRIBUTION_KINDS = [
    { value: "memory", label: "A memory or story" },
    { value: "relative", label: "A relative who is missing" },
    { value: "correction", label: "A correction to a name or date" },
    { value: "other", label: "Something else" }
] as const

export const CONTRIBUTION_KIND_VALUES: ReadonlyArray<string> = CONTRIBUTION_KINDS.map(kind => kind.value)
